import { DialogInOne } from 'src/components';
import { Circular } from 'src/components/LoadingDialog/LoadingProgressDialog';
import { Box, Typography } from 'src/components/MuiGenerals';

type UploadingDialogProps = {
  isOpen: boolean;
  progress: number;
  totalRecords: number;
  uploadingText?: string;
};

const UploadingDialog = (props: UploadingDialogProps) => {
  const { isOpen, progress, totalRecords, uploadingText } = props;

  return (
    <DialogInOne
      size="xs"
      self={{
        open: isOpen,
        onClose: () => {},
      }}
      content={
        <Box display={'flex'} flexDirection={'column'} alignItems={'center'} gap={1}>
          <Circular value={(progress / totalRecords) * 100} />
          <Typography variant="h6">{uploadingText}</Typography>
        </Box>
      }
      isConfirmHidden
      isCancelHidden
      title={''}
      onConfirm={() => {}}
      onCancel={() => {}}
    />
  );
};
export default UploadingDialog;
